





















































// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {createKeyword} from '@/api/resume';


export default {
    data() {
        return {
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            }
        }
    },

    methods: {
        onSubmit() {
            console.log('submit!');
        },

        createkeyword() {
            createKeyword({code: ""}).then()
        }
    }


}
